export interface PageableModel<T> {
    currentPage: number;
    data: T[];
    numberOfPages: number;
    numberOfElements: number;
}

export enum SortDirection {
    asc = "asc",
    desc = "desc"
}